<template>
  <div>
    <p class="title-page">Empresas</p>
    <TableEmpresas />
  </div>
</template>

<script>
import TableEmpresas from "../components/TableEmpresas.vue";

export default {
  name: "Contabilizar",

  components: {
    TableEmpresas,
  },
};
</script>
